import { RANK_LABELS, type Card } from "../game";

const SUIT_SYMBOL: Record<Card["suit"], string> = {
  hearts: "♥",
  diamonds: "♦",
  clubs: "♣",
  spades: "♠",
};

function center(rect: DOMRect): { x: number; y: number } {
  return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
}

function prefersReducedMotion(): boolean {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}

/** Anima un nodo desde un rect origen hasta un rect destino y lo elimina. */
function fly(node: HTMLElement, from: DOMRect, to: DOMRect, durationMs: number, delayMs = 0): void {
  const start = center(from);
  const end = center(to);
  node.style.position = "fixed";
  node.style.left = `${start.x}px`;
  node.style.top = `${start.y}px`;
  node.style.zIndex = "90";
  node.style.pointerEvents = "none";
  document.body.appendChild(node);

  const animation = node.animate(
    [
      { transform: "translate(-50%, -50%) scale(1)", opacity: 1 },
      {
        transform: `translate(calc(-50% + ${end.x - start.x}px), calc(-50% + ${end.y - start.y}px)) scale(0.72)`,
        opacity: 0.92,
      },
    ],
    { duration: durationMs, delay: delayMs, easing: "cubic-bezier(0.3, 0.8, 0.4, 1)", fill: "backwards" },
  );
  animation.onfinish = () => node.remove();
  animation.oncancel = () => node.remove();
}

/** Carta boca arriba volando (jugada del rival hacia la pila). */
export function flyCardFace(card: Card, fromSelector: string, toSelector: string): void {
  if (prefersReducedMotion()) return;
  const fromEl = document.querySelector(fromSelector);
  const toEl = document.querySelector(toSelector);
  if (!fromEl || !toEl) return;

  const node = document.createElement("div");
  node.className = `fx-card fx-card--face ${card.suit === "hearts" || card.suit === "diamonds" ? "is-red" : "is-black"}`;
  node.innerHTML = `<strong>${RANK_LABELS[card.rank]}</strong><span>${SUIT_SYMBOL[card.suit]}</span>`;
  fly(node, fromEl.getBoundingClientRect(), toEl.getBoundingClientRect(), 260);
}

/** Cartas boca abajo volando (el pozo levantado hacia el mazo del penalizado). */
export function flyPotToStock(
  fromSelector: string,
  toSelector: string,
  capturedCount: number,
  withBadge = true,
): void {
  if (prefersReducedMotion()) return;
  const toEl = document.querySelector(toSelector);
  const fromEl = document.querySelector(fromSelector);
  if (!fromEl || !toEl) return;
  const fromRect = fromEl.getBoundingClientRect();
  const toRect = toEl.getBoundingClientRect();

  for (let index = 0; index < 3; index += 1) {
    const node = document.createElement("div");
    node.className = "fx-card fx-card--back";
    fly(node, fromRect, toRect, 340, index * 70);
  }
  if (!withBadge) return;

  const badge = document.createElement("div");
  badge.className = "fx-badge";
  badge.textContent = `+${capturedCount}`;
  badge.style.position = "fixed";
  const target = center(toRect);
  badge.style.left = `${target.x}px`;
  badge.style.top = `${target.y}px`;
  badge.style.zIndex = "91";
  badge.style.pointerEvents = "none";
  document.body.appendChild(badge);
  const animation = badge.animate(
    [
      { transform: "translate(-50%, -50%) scale(0.6)", opacity: 0 },
      { transform: "translate(-50%, -110%) scale(1)", opacity: 1, offset: 0.35 },
      { transform: "translate(-50%, -170%) scale(1)", opacity: 0 },
    ],
    { duration: 1_050, delay: 260, easing: "ease-out", fill: "backwards" },
  );
  animation.onfinish = () => badge.remove();
  animation.oncancel = () => badge.remove();
}
